const FINE_THRESHOLD_STEPS = Array.from({ length: 101 }, (_, step) => step / 100)

function getVisibilityRatio(entry: IntersectionObserverEntry) {
  const targetArea = entry.boundingClientRect.width * entry.boundingClientRect.height
  const rootArea = entry.rootBounds ? entry.rootBounds.width * entry.rootBounds.height : targetArea
  const viewableArea = Math.min(targetArea, rootArea)
  const visibleArea = entry.intersectionRect.width * entry.intersectionRect.height

  return {
    ratio: viewableArea > 0 ? visibleArea / viewableArea : entry.intersectionRatio,
    isTallerThanViewport: targetArea > rootArea
  }
}

export function onElementVisibleAtThreshold(
  element: Ref<HTMLElement | null>,
  onVisible: () => void,
  threshold: number = 0.5
) {
  const isVisibleAtThreshold = ref(false)

  if (import.meta.server) return { isVisibleAtThreshold }

  let stopCurrent: (() => void) | undefined
  let hasEscalated = false
  let hasFired = false

  function observe(observerThreshold: number | number[]) {
    const { stop } = useIntersectionObserver(
      element,
      ([entry]) => {
        if (!entry || hasFired) return

        const { ratio, isTallerThanViewport } = getVisibilityRatio(entry)

        isVisibleAtThreshold.value = ratio >= threshold

        if (isVisibleAtThreshold.value) {
          hasFired = true
          stopCurrent?.()
          onVisible()
          return
        }

        if (isTallerThanViewport && !hasEscalated) {
          hasEscalated = true
          stopCurrent?.()
          observe(FINE_THRESHOLD_STEPS)
        }
      },
      { threshold: observerThreshold }
    )

    stopCurrent = stop
  }

  observe(threshold)

  if (getCurrentScope()) {
    onScopeDispose(() => stopCurrent?.())
  }

  return { stop: () => stopCurrent?.(), isVisibleAtThreshold }
}
